import { Injectable } from '@angular/core';
import { ICalendar } from 'src/app/admin/service-setup/iCalendar.model';

@Injectable({ providedIn: 'root' })
export class ExportService {
  constructor() {}

  ConvertAttendanceToCSV(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = 'S#,';
    for (let index in headerList) {
      row += "\"" + headerList[index] + "\"" + ',';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
      let gradestr = array[i]['grade'] == null? '': array[i]['grade'].toString().replace(/\,/g, ' '); 
      let line = i + 1 + ', ' + array[i]['name'].toString().replace(/\,/g, ' ') + ', ' + gradestr;
      for (let index in array[i]['attendanceSlots']) {
        //let val = array[i]['attendanceSlots'][index] == 0? '':'1';
        line += ',' + array[i]['attendanceSlots'][index];
      }
      str += line + '\r\n';
    }  
    return str;
  }
 
  ConvertToCSV(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = 'S#,';
    for (let index in headerList) { 
      row += headerList[index] + ',';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
      let line = i + 1 + '';
      for (let index in headerList) {
          let head = headerList[index].toString().replace(/\,/g, ' ');
          line += ',' + array[i][head].toString().replace(/\,/g, ' ');
      }
      str += line + '\r\n';
    }
    return str;
  }

  ConvertToCSVWithKey(objArray, dateArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = 'S#,';
    for (let index in headerList) {
      row += headerList[index] + ',';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
      let line = i + 1 + '';
      for (let index in headerList) {
        let head = headerList[index].replace(/\,/g, ' ');
        if (array[i].filter((x) => x.key == head).length > 0)
          line += ',"' + array[i].filter((x) => x.key == head)[0].value+'"';
        else line += ',';
      }
      str += line + ',' + dateArray[i] + '\r\n';
    }
    return str;
  }

  ConvertToICalendar(data: ICalendar[]) {
    const newLine = '\r\n';
    let str = 'BEGIN:VCALENDAR' + newLine;
    data.forEach((a) => {
      str = str + 'BEGIN:VEVENT' + newLine;
      str = str + 'SUMMARY:' + a.summary + newLine;
      str = str + 'DTSTART:' + a.start + newLine;
      str = str + 'DTEND:' + a.end + newLine;
      str = str + 'LOCATION:' + a.location + newLine;
      str = str + 'DESCRIPTION:' + a.description + newLine;
      str = str + 'END:VEVENT' + newLine;
    });
    str = str + 'END:VCALENDAR' + newLine;
    return str;
  }

  downloadICalendar(data, filename = 'Calendar') {
    let icalData = this.ConvertToICalendar(data); 
    let blob = new Blob([icalData], {
      type: 'text/calendar',
    });
    let dwldLink = document.createElement('a');
    let url = URL.createObjectURL(blob);
    dwldLink.setAttribute('href', url);
    dwldLink.setAttribute('download', filename);
    dwldLink.setAttribute('target', 'self');
    dwldLink.style.visibility = 'hidden';
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  downloadFile(data, headerList, filename = 'data') {
    let csvData = this.ConvertToCSV(data, headerList);
    const bom = "\ufeff";
    let blob = new Blob([bom + csvData], {
      type: 'text/csv;charset=utf-8-sig-sig;',
    });
    let dwldLink = document.createElement('a');
    let url = URL.createObjectURL(blob);
    dwldLink.setAttribute('href', url);
    dwldLink.setAttribute('download', filename + '.csv');
    dwldLink.style.visibility = 'hidden';
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  downloadAttendanceFile(data, headerList, filename = 'data') {
    let csvData = this.ConvertAttendanceToCSV(data, headerList);
    const bom = "\ufeff";
    let blob = new Blob([bom + csvData], {
      type: 'text/csv;charset=utf-8-sig-sig;',
    });
    let dwldLink = document.createElement('a');
    let url = URL.createObjectURL(blob);
    dwldLink.setAttribute('href', url);
    dwldLink.setAttribute('download', filename + '.csv');
    dwldLink.style.visibility = 'hidden';
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }  

  downloadFileWithKey(data, creationDates, headerList, filename = 'data') {
    let csvData = this.ConvertToCSVWithKey(data, creationDates, headerList);
    const bom = "\ufeff";
    let blob = new Blob([bom + csvData], {
      type: 'text/csv;charset=utf-8-sig-sig;',
    });
    let dwldLink = document.createElement('a');
    let url = URL.createObjectURL(blob);
    dwldLink.setAttribute('href', url);
    dwldLink.setAttribute('download', filename + '.csv');
    dwldLink.style.visibility = 'hidden';
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }
}
